export default __webpack_public_path__ + "static/media/Thumb_Shoes_03.084b0617.png";